export default [
  {
    name: 'reports',
    path: '/reports',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Relatórios',
      icon: 'dvr',
      label: 'Relatórios'
    },
    children: [
      { path: '/reports/participants', component: () => import(/* webpackChunkName: "event" */ './participants/Index.vue'), name: 'report-participants' },
      { path: '/reports/orders', component: () => import(/* webpackChunkName: "event" */ './orders/Index.vue'), name: 'report-orders' },
      { path: '/reports/indication', component: () => import(/* webpackChunkName: "event" */ './indication/Index.vue'), name: 'report-indication' },
      { path: '/reports/feed-timeline', component: () => import(/* webpackChunkName: "event" */ './timeline/Index.vue'), name: 'report-feed-timeline' },
      { path: '/reports/askings', component: () => import(/* webpackChunkName: "event" */ './askings/Index.vue'), name: 'report-askings' },
      { path: '/reports/emojis', component: () => import(/* webpackChunkName: "event" */ './emojis/Index.vue'), name: 'report-emojis' },
      { path: '/reports/quiz', component: () => import(/* webpackChunkName: "event" */ './quiz/Index.vue'), name: 'report-quiz' },
      { path: '/reports/polls', component: () => import(/* webpackChunkName: "event" */ './poll/Index.vue'), name: 'report-polls' },
      { path: '/reports/satisfaction-survey', component: () => import(/* webpackChunkName: "event" */ './survey/Index.vue'), name: 'report-satisfaction-survey' },
      { path: '/reports/generated-certificates', component: () => import(/* webpackChunkName: "event" */ './certificates/Index.vue'), name: 'report-generated-certificates' },
      { path: '/reports/word-cloud', component: () => import(/* webpackChunkName: "event" */ './word-cloud/Index.vue'), name: 'report-word-cloud' },
      { path: '/reports/gamification', component: () => import(/* webpackChunkName: "event" */ './gamification/Index.vue'), name: 'report-gamification' },
      { path: '/reports/logs-auth', component: () => import(/* webpackChunkName: "event" */ './logs-auth/Index.vue'), name: 'report-logs-auth' }
    ]
  }
]
